import * as React from 'react'

export const MapContext = React.createContext(null)

const defaults = {
	defaultCenter: {
		lat: 35.873124072932455,
		lng: -119.33398496710643,
	},
	defaultZoom: 7,
}

export const MapProvider = ({ children }) => {
	const [$geocoder, set$geocoder] = React.useState(() => {})

	const [$center, set$center] = React.useState(defaults.defaultCenter)
	const [$zoom, set$zoom] = React.useState(defaults.defaultZoom)

	const [$showOB, set$showOB] = React.useState(true)
	const [$bounds, set$bounds] = React.useState({})

	function checkIfOB({ lat, lng }) {
		if (!$bounds || !lat || !lng) return false

		const lat_isOB = lat > $bounds.nw?.lat || lat < $bounds.sw?.lat
		const lng_isOB = lng > $bounds.se?.lng || lng < $bounds.sw?.lng

		return lat_isOB || lng_isOB
	}

	function resetMap() {
		set$center(defaults.defaultCenter)
		set$zoom(defaults.defaultZoom)
	}

	const value = {
		defaults,
		$geocoder,
		set$geocoder,
		$center,
		set$center,
		$zoom,
		set$zoom,
		$showOB,
		set$showOB,
		$bounds,
		set$bounds,
		checkIfOB,
		resetMap,
	}

	return <MapContext.Provider value={value} children={children} />
}
